import { useQueries, UseQueryResult } from '@tanstack/react-query';

import { getConsistencyCheckBranchMoIds } from '@api/consistencyCheck';

import { fieldsOptionsFormatted } from '@utils/formatter';

import { IMoTreeFilters } from '@interfaces/cmModule/cmModule';
import { IComparisonId, IMoNames } from '@interfaces/cmModule/dto/cmModuleDTO';

import { CONSISTENCY_DETAILS_MO_FILTERS } from '@constants/queryKeys';

interface IUseQueriesConsistencyCheckDetailsMoFiltersReturnType {
	isLoadingDetailsMoFilters: boolean;
	detailsMoFilters: IMoTreeFilters[];
}

export const useQueriesConsistencyCheckDetailsMoFilters = (
	params: IComparisonId & IMoNames,
): IUseQueriesConsistencyCheckDetailsMoFiltersReturnType => {
	const { moNames, comparisonId } = params;

	const moIds = useQueries({
		queries: moNames.map((moName) => ({
			queryKey: [CONSISTENCY_DETAILS_MO_FILTERS, params],
			queryFn: () => getConsistencyCheckBranchMoIds({ moName, comparisonId }),
			enabled: !!moName.length,
			staleTime: Infinity,
		})),
	});

	return {
		isLoadingDetailsMoFilters:
			moIds.some((result: UseQueryResult<string[]>) => result.isInitialLoading || result.isFetching),
		detailsMoFilters: moIds.map((result: UseQueryResult<string[]>, index) => ({
			moName: moNames[index],
			data: fieldsOptionsFormatted(result.data || [])
				.map((option) => ({
					...option,
					name: moNames[index],
				})),
		})),
	};
};
